"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alerta = void 0;
// Alerta.tsx
var react_1 = __importStar(require("react"));
var Icone_1 = require("../Icone/Icone");
var Botao_1 = require("../Botao/Botao");
var Corpo_1 = require("../Tipografia/Corpo/Corpo");
var Cores_1 = require("../Cores/Cores");
var estiloAlerta = require("./Alerta.module.scss");
var obterCorTexto = function (tipo, estilo) {
    var coresPorTipo = {
        error: Cores_1.Cores.MensagensDoSistema.VermelhoMU,
        warning: Cores_1.Cores.MensagensDoSistema.LaranjaMU,
        info: Cores_1.Cores.GradacaoPrimaria.AzulMedioMU600,
        success: Cores_1.Cores.MensagensDoSistema.VerdeMU,
    };
    if (estilo === "filled") {
        return Cores_1.Cores.CoresIdentidadeMU.brancoMu;
    }
    return coresPorTipo[tipo];
};
var Alerta = function (_a) {
    var id = _a.id, _b = _a.tipo, tipo = _b === void 0 ? "warning" : _b, _c = _a.estilo, estilo = _c === void 0 ? "standard" : _c, icone = _a.icone, titulo = _a.titulo, descricao = _a.descricao, _d = _a.limiteCaracteresExibicaoDescricao, limiteCaracteresExibicaoDescricao = _d === void 0 ? 100 : _d, _e = _a.exibirBotaoFechar, exibirBotaoFechar = _e === void 0 ? true : _e, _f = _a.esconderTextoExtenso, esconderTextoExtenso = _f === void 0 ? false : _f, limiteLinhasExibicao = _a.limiteLinhasExibicao, alinhamentoTexto = _a.alinhamentoTexto, larguraDescricao = _a.larguraDescricao, onFechar = _a.onFechar, onVerMais = _a.onVerMais, validadeInicial = _a.validadeInicial, validadeFinal = _a.validadeFinal, _g = _a.pausarTimeout, pausarTimeout = _g === void 0 ? false : _g;
    var _h = (0, react_1.useState)(null), progresso = _h[0], setProgresso = _h[1];
    (0, react_1.useEffect)(function () {
        if (validadeInicial && validadeFinal && !pausarTimeout) {
            var agora = new Date().getTime();
            if (agora < validadeInicial || agora > validadeFinal) {
                if (onFechar)
                    onFechar();
                return;
            }
            var duracao_1 = validadeFinal - validadeInicial;
            var intervalo_1 = setInterval(function () {
                var tempoAtual = new Date().getTime();
                var progressoAtual = ((validadeFinal - tempoAtual) / duracao_1) * 100;
                setProgresso(Math.max(progressoAtual, 0));
                if (tempoAtual >= validadeFinal) {
                    clearInterval(intervalo_1);
                    if (onFechar)
                        onFechar();
                }
            }, 50);
            return function () { return clearInterval(intervalo_1); };
        }
    }, [validadeInicial, validadeFinal, onFechar, pausarTimeout]);
    (0, react_1.useEffect)(function () {
        if (validadeInicial && validadeFinal)
            setProgresso(((validadeFinal - new Date().getTime()) /
                (validadeFinal - validadeInicial)) *
                100);
    }, []);
    var tipos = estiloAlerta[tipo] || "";
    var estilos = estiloAlerta[estilo] || "";
    var corTexto = obterCorTexto(tipo, estilo);
    var corTipo = obterCorTexto(tipo, estilo);
    var tituloAlerta = (react_1.default.createElement(Corpo_1.Corpo, { tipo: "body1", negrito: 700, cor: corTipo }, titulo));
    var descricaoAlerta = (react_1.default.createElement(Corpo_1.Corpo, { tipo: "body3", cor: corTipo, style: esconderTextoExtenso
            ? {
                textOverflow: "ellipsis",
                textAlign: alinhamentoTexto !== null && alinhamentoTexto !== void 0 ? alinhamentoTexto : "left",
                width: larguraDescricao !== null && larguraDescricao !== void 0 ? larguraDescricao : "100%",
                overflow: "hidden",
                display: "-webkit-box",
                WebkitLineClamp: limiteLinhasExibicao !== null && limiteLinhasExibicao !== void 0 ? limiteLinhasExibicao : 10,
                WebkitBoxOrient: "vertical",
            }
            : undefined }, (descricao === null || descricao === void 0 ? void 0 : descricao.slice(0, limiteCaracteresExibicaoDescricao)) ||
        descricao));
    var iconeAlerta = (react_1.default.createElement("div", { className: estiloAlerta.icones }, icone ? icone : react_1.default.createElement(Icone_1.Icone, { nome: tipo })));
    var botaoFechar = (react_1.default.createElement("div", null,
        react_1.default.createElement(Botao_1.Botao, { tamanho: "xsmall", estilo: "ghost", onClick: onFechar !== null && onFechar !== void 0 ? onFechar : undefined },
            react_1.default.createElement(Icone_1.Icone, { nome: "close", cor: corTipo }))));
    return (react_1.default.createElement("div", { id: id, className: "".concat(estiloAlerta.alert, " ").concat(tipos, " ").concat(estilos) },
        react_1.default.createElement("div", { className: estiloAlerta.container },
            react_1.default.createElement("div", { className: estiloAlerta.content },
                iconeAlerta,
                react_1.default.createElement("div", { className: "".concat(estiloAlerta.textos) },
                    titulo && tituloAlerta,
                    descricaoAlerta)),
            exibirBotaoFechar && botaoFechar),
        onVerMais && (tipo === "error" || tipo === "warning") && (react_1.default.createElement("div", { className: estiloAlerta.mostrarMais },
            react_1.default.createElement(Botao_1.Botao, { tamanho: "small", estilo: "ghost", onClick: function () { return onVerMais(); }, style: { width: "100px" } },
                react_1.default.createElement(Corpo_1.Corpo, { tipo: "button2", negrito: 700, cor: corTexto }, "Ver Mais")))),
        react_1.default.createElement("div", { className: estiloAlerta.progresso, style: { width: "".concat(progresso !== null && progresso !== void 0 ? progresso : 99.5, "%") } })));
};
exports.Alerta = Alerta;
